<mat-card class="shadow-none p-8 m-b-0 p-b-0">
  <mat-card-title class="p-16 pb-0! d-flex justify-content-between">
    <span class="mat-mdc-card-title">{{ 'import process' | translate }}</span>
    <span (click)="onClose()">
      <i-tabler name="x" class="icon-20 w-8 d-flex rounded cursor-pointer aspect-square hover:bg-[var(--mat-color-light-table-hover)] hover:text-[var(--mat-sys-primary)] dark:hover:bg-[var(--striped-row-background-color)] dark:hover:text-[var(--mat-color-primary)]"/>
    </span>
  </mat-card-title>
  
  <mat-dialog-content class="flex gap-16 p-16 !pb-0">
    <input #fileInput type="file" accept=".xlsx" hidden (change)="onFileChange($event)" />
    <div
      class="border px-4! min-h-20 rounded border-[var(--mat-sys-primary)] border-dashed flex justify-center items-center cursor-pointer"
      [class.border-primary]="isDragging"
      (click)="fileInput.click()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
    >
      @if (selectedFile) {
        <div class="text-gray-600">{{ selectedFile.name }}</div>
      } @else {
        <i-tabler class="text-primary" name="upload" />
      }
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end" class="gap-8 p-16">
    <app-form-button class="bg-transparent!" [spinLoader]="isLoading" [btnConfig]="cancelButtonConfig" />
    <button mat-flat-button color="primary" [disabled]="!selectedFile || isLoading" (click)="onImport()">
      <div class="d-flex align-items-center text-disable">
        <app-loading-icon [loading]="isLoading"/>
        {{ 'import' | translate }}
      </div>
    </button>
  </mat-dialog-actions>
</mat-card>
